export default defineNuxtRouteMiddleware(() => {
  const error = useError();
  if (error.value) {
    clearError();
  }
});
